module.exports = __webpack_public_path__ + "static/media/print-instrucoes-conta-3.07c628b5.png";